import { styled } from 'styled-components'

import { StyledInfoIcon } from '@nx/fire/info-box'

export const LotCardAMWrapper = styled.div<{
  $hasHammerPrice?: boolean
  $hasTopMargin?: boolean
}>`
  ${StyledInfoIcon} {
    display: none;
  }

  .am-data {
    > div:first-child {
      margin-top: ${({ $hasTopMargin }) => ($hasTopMargin ? '10px' : '0')};
    }

    .am-bid-status-label {
      > div:first-child {
        padding-left: 0;
        padding-right: 0;
      }

      .current-label,
      .current-bid {
        width: auto;
        ${({ theme }) => theme.fontStyles.sourceSans.regular}
        color: ${({ theme }) => theme.colours.primary.black};
        font-weight: 600 !important;
        font-size: 16px !important;
      }

      .current-label::after {
        content: ':';
      }

      .win.winning {
        .current-label,
        .current-bid {
          color: ${({ theme }) => theme.colours.status.success} !important;
        }
      }

      .lost.outbid {
        .current-label,
        .current-bid {
          color: ${({ theme }) => theme.colours.status.error} !important;
        }
      }
    }

    .am-lot-status-label {
      width: auto;

      > div:first-child {
        ${({ theme }) => theme.fontStyles.sourceSans.regular}
        font-weight: 600 !important;
        font-size: 16px !important;
      }

      [class='sold'] {
        display: ${({ $hasHammerPrice }) =>
          $hasHammerPrice ? 'none' : 'block'};
      }

      .lost.outbid,
      .win.sold,
      .lost.sold {
        padding-left: 0;
      }

      .win.sold,
      .lost.sold {
        padding-bottom: 0;
      }

      .lost.sold {
        color: ${({ theme }) => theme.colours.grey['75']};
      }

      .lost.outbid {
        color: ${({ theme }) => theme.colours.status.error};
      }

      .win.sold {
        color: ${({ theme }) => theme.colours.status.success};
      }
    }

    .am-bid-box {
      width: fit-content;

      ${({ theme }) => theme.fontStyles.sourceSans.regular}
      > div:first-child {
        padding: 0;
        width: fit-content;
      }

      .bid-controls .bid-label.bid-price {
        font-size: 16px !important;
        font-weight: 600 !important;
        padding-top: 15px;

        &.win.winning {
          color: ${({ theme }) => theme.colours.status.success} !important;
        }

        &.lost {
          color: ${({ theme }) => theme.colours.status.error} !important;
        }
      }

      .bid-button-edit,
      .bid-button {
        color: ${({ theme }) => theme.colours.primary.black} !important;
        font-size: 16px !important;
        font-weight: 600 !important;
        width: fit-content;
        border: none !important;
        text-decoration: underline;
        text-transform: none !important;
        padding: 0;
        margin: 20px 0 0;
      }
    }

    .am-timer {
      min-height: 26px;
      display: flex;
      flex-flow: row nowrap;
      ${({ theme }) => theme.fontStyles.sourceSans.regular}
      font-size: 16px !important;
      color: ${({ theme }) => theme.colours.primary.charcoal} !important;

      & > .label {
        padding: 0 !important;
        margin: 0;
        height: auto;
        font-size: 16px !important;
        color: ${({ theme }) => theme.colours.primary.charcoal} !important;

        &::after {
          content: ': ';
          white-space: pre;
        }
      }

      .time-wrapper {
        display: flex;
        flex-flow: row nowrap;
        padding: 0;

        .label {
          display: none;
        }

        .digit {
          font-size: 16px !important;
          line-height: normal;
        }

        div {
          height: auto;
          width: auto;
          background: none;
          margin: 0;
        }

        .digit::after {
          content: ':';
        }

        div:last-child {
          & > .digit::after {
            content: '';
          }
        }
      }
    }
  }
`

export const LotClosingInStringComponent = styled.div`
  color: ${({ theme }) => theme.colours.primary.charcoal} !important;
`
